<template>
  <div class="registerBox">
    <h2 class="formBox" style="margin-bottom: 10px">
      {{ $t("button.zhuce") }}
    </h2>
    <el-form
      ref="ruleForm"
      :model="form"
      class="formBox"
      :rules="rules"
      label-width="120px"
      label-position="top"
    >
      <el-form-item :label="$t('register.fapiaoyewubianma')" prop="faPiaoId">
        <el-input v-model="form.faPiaoId"></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.email')" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.mima')" prop="password">
        <el-input v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item>
        <p>{{ $t("register.shenfenzhengxinxi") }}</p>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.xingbie')">
        <el-radio-group v-model="form.sex">
          <el-radio label="男">男</el-radio>
          <el-radio label="女">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('register.shengrinianyueri')" prop="birthday">
        <el-date-picker
          value-format="yyyy-MM-DD"
          type="date"
          v-model="form.birthday"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('register.dianhuafanhao')" prop="telephone">
        <el-input v-model="form.telephone"></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.zhiye')" prop="job">
        <el-input v-model="form.job"></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.youbianfanhao')" prop="postalCode">
        <el-input v-model="form.postalCode"></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.zhusuo')" prop="address">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item style="text-align: center">
        <el-button type="success" @click="onSubmit('ruleForm')">{{
          $t("register.querenzhuce")
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { regeister } from "@/api/user";
export default {
  components: {},
  props: {},
  data() {
    return {
      isToCart: false,
      form: {
        faPiaoId: "",
        name: "",
        sex: "男",
        email: "",
        password: "",
        address: "",
        birthday: "",
        telephone: "",
        job: "",
        postalCode: "",
      },
      rules: {
        faPiaoId: [
          {
            required: true,
            message:
              this.$t("rules.qingxuanze") +
              this.$t("register.fapiaoyewubianma"),
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [
          {
            required: true,
            message: this.$t("rules.qingxuanze") + this.$t("register.email"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("rules.qingxuanze") + this.$t("register.mima"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("rules.qingxuanze") + this.$t("register.zhusuo"),
            trigger: "blur",
          },
        ],
        birthday: [
          {
            required: true,
            message:
              this.$t("rules.qingxuanze") +
              this.$t("register.shengrinianyueri"),
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            message:
              this.$t("rules.qingxuanze") + this.$t("register.dianhuafanhao"),
            trigger: "blur",
          },
        ],
        job: [
          {
            required: true,
            message: this.$t("rules.qingxuanze") + this.$t("register.zhiye"),
            trigger: "blur",
          },
        ],
        postalCode: [
          {
            required: true,
            message:
              this.$t("rules.qingxuanze") + this.$t("register.youbianfanhao"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.$route.query.rediect
      ? (this.isToCart = true)
      : (this.isToCart = false);
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          regeister(this.form).then((res) => {
            this.$message({
              message: res.message,
              type: "success",
            });
            sessionStorage.setItem("userInfo", this.form.name);
            sessionStorage.setItem("userID", res.data.userId);

            if (this.isToCart) {
              console.log(666);
              this.$router.push("/shoppingCart");
            } else {
              this.$router.push({
                name: "ShopList",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.registerBox {
  width: 100%;
  padding: 20px 15px;
  box-sizing: border-box;
}
.formBox {
  width: 50%;
  margin: 0 auto;
}
@media screen and (max-width: 768px) {
  .formBox {
    width: 100%;
  }
}
</style>